export const changeThemeColor = (receivedTheme, defaultTheme, highlightedTextsInDefaultColor) => {  
  const updatedTheme = {
    ...defaultTheme,
    highlightedTextsInDefaultColor: !!highlightedTextsInDefaultColor,
    colors: {
      ...defaultTheme.colors, // Copia todas as cores originais
      primary: {
        ...defaultTheme.colors.primary, // Copia todas as propriedades de "primary"
        default: receivedTheme?.defaultColor || defaultTheme.colors.primary.default,
        dark: receivedTheme?.dark || defaultTheme.colors.primary.dark,
        light: receivedTheme?.light || defaultTheme.colors.primary.light,
        fontColor: receivedTheme?.fontColor || defaultTheme.colors.primary.fontColor,
      },
      secondary: {
        ...defaultTheme.colors.secondary,
        // Se não tem .colors, é porque está recebendo um tema customizado
        default: (receivedTheme && !receivedTheme?.colors) ? defaultTheme?.colors?.mono?.grey : defaultTheme?.colors.secondary.default,
        light: (receivedTheme && !receivedTheme?.colors) ? defaultTheme?.colors?.mono?.grey : defaultTheme?.colors.secondary.default,
      },
    }
  }
  return updatedTheme
}